import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    box: {
        width: '100%',
        height: '100%',
    },
    stackTop: {
        zIndex: 9,
        position: 'absolute',
        top: 0,
        left: 0,
    },
}));

const Overlay = ({
    children,
    overlay,
    opacity = 0.4,
    condition,
    innerRef,
    ...props
}) => {
    const classes = useStyles();

    return (
        <div className={classes.container} ref={innerRef}>
            <Box
                className={classes.box}
                style={{opacity: condition ? opacity : null}}
            >
                {children}
            </Box>
            {condition ? (
                <Box className={clsx(classes.box, classes.stackTop)}>
                    {overlay}
                </Box>
            ) : null}
        </div>
    );
};

export default Overlay;
